import { tokens } from '@cast/design-system';

/** Text action link used by Meta View → and “view N more”. */
export const metaTextLinkSx = {
  color: tokens.theme.fg.action.primary,
  px: 0,
  py: 2,
  minHeight: 0,
  typography: 'P12M',
} as const;
